"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyUtils = void 0;
const getSymbol = (currency) => {
    if (currency === "euro")
        return "€";
    if (currency === "usdollar")
        return "$";
    return "";
};
exports.currencyUtils = {
    getSymbol,
};
//# sourceMappingURL=currencyUtils.js.map